import './easter';

import angularMaterial from 'angular-material';
import angularRoute from 'angular-route';

import routes from './routes';
import debug from './debug';
import csrf from './csrf';
import materialTheme from './material-theme';
import configProvider from './config-provider';
import routeScrollTop from './route-scroll-top';
import setRootScopeConfig from './set-rootscope-config';

export default angular.module('config', [angularMaterial, angularRoute])
    .config(debug)
    .config(routes)
    .config(csrf)
    .config(materialTheme)
    .provider('config', configProvider)
    .run(routeScrollTop)
    .run(setRootScopeConfig)
    .name;



// WEBPACK FOOTER //
// ./config/config-module.js